import { handleAuthenticationError } from '../../util/sessionExpiry';
import {
  QueryResult,
  MutationResult,
  OperationVariables,
  LazyQueryResult,
} from '@apollo/client';
import { useEffect } from 'react';
import { errors } from './errors';
import { useToasts } from '../../graphql/toasts/useToasts';

export const DEFAULT_ERROR = 'Something went wrong, please try again';

export const useErrorHandler = <
  TData = any,
  TVariables extends OperationVariables = Record<string, any>,
>(
  queryResult:
    | QueryResult<TData, TVariables>
    | MutationResult<TData>
    | LazyQueryResult<TData, TVariables>,
) => {
  const { pushToast } = useToasts();
  const { data, error, loading } = queryResult;

  useEffect(() => {
    if (error && !loading) {
      if (handleAuthenticationError(error)) return;

      const errorMessage = Object.keys(errors).includes(error.message)
        ? errors[error.message]
        : error.message;
      pushToast({
        variables: { toast: { message: errorMessage || DEFAULT_ERROR } },
      });
    }
  }, [loading, error, pushToast]);

  return { data, error, loading };
};
